module.exports = __webpack_public_path__ + "static/media/conversationx.37ac8bf9.svg";